import React, { Suspense } from 'react'
import routerConfig, { generalRouter } from '../config/router.config'
import { Route, Redirect, Switch } from 'react-router-dom'

let routes = []
const RouterMain = () => {
		routerConfig.General.forEach((publicRoute, i) => {
			routes.push(
				<Route
					key={`routerGeneral${i}`}
					exact
					path={publicRoute.path}
					component={publicRoute.component}
				/>
			)
		})
	return (
		<Suspense fallback={<div />}>
			{
				<>
					<Switch>
						{routes}
						<Route
							exact
							path='*'
							render={() => {
								return <Redirect to={generalRouter.home} />
							}}
						/>
					</Switch>
				</>
			}
		</Suspense>
	)
}
export default RouterMain
